import { Button } from "../ui/button.tsx";

import {
    HelpCircle,
    MoreHorizontal,
    Plus,
    Settings,
    PanelRight,
} from "lucide-react";

import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet.tsx";
import clsx from "clsx";
import Workspaces from "./Workspaces.jsx";
import { useFormEditorContext } from "../../Contexts/FormEditorContext.jsx";
import {
    QuestionCircleOutlined,
    PhoneOutlined,
    SettingOutlined,
    TagOutlined,
} from "@ant-design/icons";

export function MobileSheet({
    workSpaces,
    setWorkSpaces,
    selectedWorkSpace,
    setSelectedWorkSpace,
    isCollapsed,
    setIsCollapsed,
    openChangelogPopup,
}) {
    const { usersPlan, setOpenCalendly } = useFormEditorContext();
    return (
        <Sheet>
            <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="p-0">
                    <PanelRight className="size-4" />
                </Button>
            </SheetTrigger>
            <SheetContent showOverlay side="left" className="p-0 w-80">
                <div className="flex flex-col h-full">
                    {/* Header */}
                    <div className="p-4 ">
                        <img
                            src="/loginSignup/logo.png"
                            alt="Buildform Logo"
                            className="w-[123.53px] "
                        />
                    </div>

                    {/* Workspace Section */}
                    <div className="p-4 ">
                        <Workspaces
                            //@ts-ignore
                            workSpaces={workSpaces}
                            setWorkSpaces={setWorkSpaces}
                            selectedWorkSpace={selectedWorkSpace}
                            setSelectedWorkSpace={setSelectedWorkSpace}
                            isCollapsed={isCollapsed}
                            setIsCollapsed={setIsCollapsed}
                        />
                    </div>
                    <div className="flex flex-col items-start justify-center px-3 pb-4 mt-auto">
                        <p className="mb-2 text-xs font-medium opacity-30">
                            Helps
                        </p>
                        <div className="flex flex-col gap-4 text-xs font-semibold">
                            <button className="flex items-center gap-2 text-start">
                                <a
                                    href="https://buildform.featurebase.app/help"
                                    target="_blank"
                                    className="flex items-center gap-2"
                                >
                                    <QuestionCircleOutlined />
                                    <span>Help Docs</span>
                                </a>
                            </button>

                            <button
                                onClick={() => {
                                    setOpenCalendly(true);
                                }}
                                className="flex items-center gap-2 text-start"
                            >
                                <PhoneOutlined /> Talk to us
                            </button>

                            <button
                                onClick={openChangelogPopup}
                                className="flex items-center gap-2 text-start"
                            >
                                <SettingOutlined />
                                Change logs <span id="fb-update-badge"></span>
                            </button>
                        </div>
                    </div>

                    <div
                        className={clsx(
                            `flex flex-col gap-3 pt-2 pb-3 px-3  hover:cursor-pointer `,
                            usersPlan !== "free"
                                ? "border-none"
                                : "border-t border-zinc-200",
                        )}
                    >
                        {/* Remove comments when the data is available */}
                        {/*  <div className="flex flex-col gap-1 ">
                                        <div className="flex items-center w-full gap-1">
                                            <p className="text-xs font-medium tracking-widest text-zinc-950 ">
                                                Unlimited replies remaining
                                            </p>
                                            <CircleHelp className="text-[#8590A2]" size={10} />
                                        </div>
                                        <Progress value={80} color="#2563EB" />
                                    </div>
                                    <div className="flex flex-col gap-1 ">
                                        <div className="flex items-center w-full gap-1">
                                            <p className="text-xs font-medium tracking-widest text-zinc-950 ">
                                                25 AI statements remaining
                                            </p>
                                            <CircleHelp className="text-[#8590A2]" size={10} />
                                        </div>
                                        <Progress value={50} color="#CF9FFF" />
                                    </div> */}

                        {usersPlan === "free" && (
                            <Button
                                className="w-full mx-[0.25px] mt-1 h-10 text-sm font-medium text-white bg-[#191B33] hover:bg-[#191B33] flex items-center gap-2 rounded-lg "
                                /* onClick={() => {
                                    setShowPricingModal(true);
                                }} */
                            >
                                Upgrade to PRO
                                <svg
                                    width="15"
                                    height="19"
                                    viewBox="0 0 15 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M4.43205 11.479C5.00785 11.479 5.56007 11.2503 5.96722 10.8431C6.37437 10.436 6.6031 9.88378 6.6031 9.30798C6.6031 8.10956 6.16889 7.57113 5.73468 6.70271C4.80374 4.84169 5.54016 3.18213 7.47152 1.49219C7.90574 3.66324 9.20837 5.74745 10.9452 7.13692C12.6821 8.5264 13.5505 10.1764 13.5505 11.9132C13.5505 12.7115 13.3932 13.502 13.0877 14.2396C12.7822 14.9771 12.3345 15.6472 11.77 16.2117C11.2055 16.7762 10.5354 17.224 9.79784 17.5295C9.06031 17.835 8.26982 17.9922 7.47152 17.9922C6.67323 17.9922 5.88274 17.835 5.14521 17.5295C4.40768 17.224 3.73754 16.7762 3.17306 16.2117C2.60858 15.6472 2.16081 14.9771 1.85531 14.2396C1.54981 13.502 1.39258 12.7115 1.39258 11.9132C1.39258 10.912 1.7686 9.92108 2.261 9.30798C2.261 9.88378 2.48973 10.436 2.89689 10.8431C3.30404 11.2503 3.85625 11.479 4.43205 11.479Z"
                                        fill="url(#paint0_linear_7710_2613)"
                                        stroke="url(#paint1_linear_7710_2613)"
                                        stroke-width="1.30263"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_7710_2613"
                                            x1="7.47152"
                                            y1="1.49219"
                                            x2="7.47152"
                                            y2="17.9922"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#FFC400" />
                                            <stop
                                                offset="1"
                                                stop-color="#FF9500"
                                            />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_7710_2613"
                                            x1="7.47152"
                                            y1="1.49219"
                                            x2="7.47152"
                                            y2="17.9922"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#3A3A3A" />
                                            <stop
                                                offset="1"
                                                stop-color="#FF9500"
                                            />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </Button>
                        )}
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
